/**
 * @fileoverview Variant Grid Component
 *
 * Purpose: Grid layout for displaying component variants
 * Used by: Component library showcases
 */

import { cn } from "@/utils/misc";

interface VariantGridProps {
  children: React.ReactNode;
  columns?: 2 | 3 | 4 | 5 | 6;
  className?: string;
}

export function VariantGrid({
  children,
  columns = 4,
  className,
}: VariantGridProps) {
  const gridCols = {
    2: "grid-cols-2",
    3: "grid-cols-3",
    4: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4",
    5: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-5",
    6: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6",
  };

  return (
    <div className={cn("grid gap-4", gridCols[columns], className)}>
      {children}
    </div>
  );
}

interface VariantItemProps {
  label: string;
  children: React.ReactNode;
  className?: string;
}

export function VariantItem({ label, children, className }: VariantItemProps) {
  return (
    <div className={cn("flex flex-col gap-3", className)}>
      <span className="text-xs font-medium text-muted-foreground">{label}</span>
      <div className="flex items-center justify-center rounded-md border bg-background/50 p-4">
        {children}
      </div>
    </div>
  );
}
